// features/user/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    userConfigure: {
      timeZone: "UTC-06:00", // Valor por defecto (México)
      language: "es", // Valor por defecto (Español)
    },
  },
  reducers: {
    setUserConfigure: (state, action) => {
      try {
        state.userConfigure = {
          ...state.userConfigure,
          ...action.payload,
        };
      } catch (error) {
        state.error = error.message; // Mantengo tu manejo de errores
      }
    },
    setTimeZone: (state, action) => {
      // Añadimos un reducer específico para timeZone
      try {
        state.userConfigure = {
          ...state.userConfigure,
          timeZone: action.payload,
        };
      } catch (error) {
        state.error = error.message;
      }
    },
    setLanguage: (state, action) => {
      // Añadimos un reducer específico para language
      try {
        state.userConfigure = {
          ...state.userConfigure,
          language: action.payload,
        };
      } catch (error) {
        state.error = error.message;
      }
    },
  },
});

export const { setUserConfigure, setTimeZone, setLanguage } = userSlice.actions;
export default userSlice.reducer;

// Selectores para acceder al estado
export const selectUserLanguage = (state) => state.user.userConfigure.language;
export const selectUserTimeZone = (state) => state.user.userConfigure.timeZone;
